// product-family-cards

function swapCardsForProductStyleOptions(option, value, swiper, sticky = false) {
  return
  if (option !== 'hem') return

  const productInfo = document.querySelector('product-info')
  if (!productInfo) return

  const currentFabric = productInfo.dataset.styleFabric

  const productFamilyCards = sticky
    ? document.querySelector('.product-family-cards--sticky')
    : document.querySelector('.product-family-cards')
  if (!productFamilyCards) return

  const cards = productFamilyCards.querySelectorAll('.product-family-card')
  cards.forEach((card) => {
    const isSameFabric = card.dataset.styleFabric?.toLowerCase() === currentFabric?.toLowerCase()
    const matchesNewHem = card.dataset.styleHem?.toLowerCase() === value?.toLowerCase()
    if (
      card.dataset.productFamily !== 'short-sleeve-curved-hem-classic-crew' &&
      card.dataset.productFamily !== 'short-sleeve-classic-crew'
    ) {
      card.style.display = 'none'
    }
    card.classList.remove('active')
    if (matchesNewHem || typeof card.dataset.styleHem === 'undefined') {
      card.style.display = 'block'
      if (matchesNewHem && isSameFabric) {
        card.classList.add('active')
      }
    }
  })
  swiper.update()
}

function initializeProductFamilyCirclesSwiper() {
  const productFamilyCards = document.querySelector('.product-family-cards')
  if (!productFamilyCards) return

  const swiperElement = productFamilyCards.closest('.js-swiper')
  if (!swiperElement) return

  if (typeof Swiper === 'undefined') return console.error('Swiper is not loaded')

  const swiperContainer = document.querySelector('.product-family-cards__swiper-container')
  const swiperPrevButton = swiperContainer?.querySelector('.swiper-button-prev')
  const swiperNextButton = swiperContainer?.querySelector('.swiper-button-next')

  try {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      slidesOffsetAfter: 10,
      slidesOffsetBefore: 10,
      breakpoints: {
        768: {
          spaceBetween: 10,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          centerInsufficientSlides: true,
        },
      },
      navigation: {
        nextEl: swiperNextButton,
        prevEl: swiperPrevButton,
      },
      on: {
        beforeInit: () => {
          const container = document.querySelector('.product-family-cards-container')
          if (!container) return
          container.style.overflow = 'unset'
          swiperContainer.style.width = 'auto'
        },
        afterInit: () => {
          setTimeout(() => {
            swiperPrevButton.classList.remove('loading')
            swiperNextButton.classList.remove('loading')
          }, 100)
        },
      },
    })
    productFamilyCards.classList.remove('swiper-loading')

    document.addEventListener('product-style-updated', (e) =>
      swapCardsForProductStyleOptions(e.detail.styleOption, e.detail.styleValue, swiper),
    )

    return swiper
  } catch (error) {
    console.error('Failed to initialize Swiper:', error)
  }
}

function initializeProductFamilyCardsSwiper() {
  const productFamilyCards = document.querySelector('.product-family-cards')
  if (!productFamilyCards) return

  const swiperElement = productFamilyCards.closest('.js-swiper')
  if (!swiperElement) return

  // find original top level container on PDP (if we're on a PDP)
  const onPDP = !!productFamilyCards.closest(
    '.product-family-cards-container.pfc-product.pfc-original',
  )
  const numVisibleCards = productFamilyCards.querySelectorAll(
    '.product-family-card:not([style*="display: none"])',
  ).length

  if (typeof Swiper === 'undefined') return console.error('Swiper is not loaded')

  const swiperContainer = document.querySelector('.product-family-cards__swiper-container')
  const swiperPrevButton = swiperContainer?.querySelector('.swiper-button-prev')
  const swiperNextButton = swiperContainer?.querySelector('.swiper-button-next')

  try {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      slidesOffsetAfter: 10,
      slidesOffsetBefore: 10,
      breakpoints: {
        769: {
          spaceBetween: 10,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        },
      },
      navigation: {
        nextEl: swiperNextButton,
        prevEl: swiperPrevButton,
      },
      on: {
        afterInit: () => {
          setTimeout(() => {
            swiperPrevButton.classList.remove('loading')
            swiperNextButton.classList.remove('loading')
          }, 100)
        },
      },
    })
    productFamilyCards.classList.remove('swiper-loading')

    document.addEventListener('product-style-updated', (e) =>
      swapCardsForProductStyleOptions(e.detail.styleOption, e.detail.styleValue, swiper),
    )

    return swiper
  } catch (error) {
    console.error('Failed to initialize Swiper:', error)
  }
}

function initializeProductFamilyCardsStickySwiper() {
  const productFamilyCards = document.querySelector('.product-family-cards--sticky')
  if (!productFamilyCards) return

  const swiperElement = productFamilyCards.closest('.js-swiper--sticky')
  if (!swiperElement) return

  if (typeof Swiper === 'undefined') return console.error('Swiper is not loaded')

  try {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      slidesOffsetAfter: 10,
      slidesOffsetBefore: 10,
      centerInsufficientSlides: true,
      breakpoints: {
        767: {
          spaceBetween: 10,
        },
      },
    })
    productFamilyCards.classList.remove('swiper-loading')

    document.addEventListener('product-style-updated', (e) =>
      swapCardsForProductStyleOptions(e.detail.styleOption, e.detail.styleValue, swiper, true),
    )

    return swiper
  } catch (error) {
    console.error('Failed to initialize Swiper:', error)
  }
}

function initializeSwipers() {
  const isClearancePage = window?.location?.pathname?.includes('top-deals-clearance')
  if (isClearancePage) {
    initializeProductFamilyCirclesSwiper()
  } else {
    initializeProductFamilyCardsSwiper()
    initializeProductFamilyCardsStickySwiper()
  }
}

document.addEventListener('DOMContentLoaded', initializeSwipers)

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.product-family-cards')) {
    initializeSwipers()
  } else {
    console.error('ERR: productFamilyCardsElement not found')
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.product-family-card-filter-on-click')
  if (!cards) return

  const filterKey = 'filter.p.m.pdp_app.info'

  cards.forEach((card) => {
    const filterValue = `gid://shopify/Metaobject/${card.dataset.productFamily}`
    card.addEventListener('click', () => {
      triggerCollectionFilters(card.dataset.collectionHandle, { [filterKey]: filterValue }, card)
    })
  })
})

async function triggerCollectionFilters(handle, params) {
  const url = new URL(`/collections/${handle}`, location.origin)
  Object.entries(params).forEach(([k, v]) =>
    Array.isArray(v) ? v.forEach((x) => url.searchParams.append(k, x)) : url.searchParams.set(k, v),
  )
  const sectionId = document.getElementById('product-grid').dataset.id
  url.searchParams.set('section_id', sectionId)

  const oldSection = document.getElementById(`shopify-section-${sectionId}`)

  oldSection.style.opacity = 0

  const html = await fetch(url).then((response) => response.text())
  const doc = new DOMParser().parseFromString(html, 'text/html')
  const newSection = doc.getElementById(`shopify-section-${sectionId}`)
  newSection.style.opacity = 0
  oldSection.replaceWith(newSection)

  setTimeout(() => {
    newSection.style.transition = 'opacity 0.5s'
    newSection.style.opacity = 1

    window.scrollToSection(newSection, 10)
  }, 500)

  history.pushState(
    {},
    '',
    `${window.Shopify.routes.root}${url.pathname.slice(1)}` +
      '?' +
      url.searchParams
        .toString()
        .replace(/section_id=[^&]*&?/g, '')
        .replace(/&$/, ''),
  )
}

// Redirect international visitors away from the US-only clearance page
function redirectInternationalClearance() {
  const nonUS = (window.Shopify?.country || 'US').toUpperCase() !== 'US'
  if (!nonUS) return

  const match = location.pathname.match(/^(.*)\/collections\/top-deals-clearance\/?$/)
  if (!match) return

  const localePrefix = match[1] // may be '' when on root market
  const newPath = `${localePrefix}/collections/top-deals-clearance-international`.replace(
    /\/\//,
    '/',
  )

  location.replace(newPath + location.search + location.hash)
}

document.addEventListener('DOMContentLoaded', redirectInternationalClearance)

async function loadCollectionGrid({
  collectionHandle,
  hostSectionSelector = '#main-collection-product-grid',
  updateURL = false,
  urlParams = {},
  callforward = () => {},
  callback = () => {},
}) {
  if (!collectionHandle) return

  callforward()

  const hostSection = document.querySelector(hostSectionSelector)
  const sectionWrapper = hostSection?.closest('.shopify-section')
  const sectionId = sectionWrapper?.id?.replace('shopify-section-', '')
  if (!hostSection || !sectionId) return

  const currentCollectionHandle = hostSection.dataset.collectionHandle
  if (currentCollectionHandle === collectionHandle) {
    callback(hostSection)
    return
  }

  try {
    const url = new URL(
      `${window.Shopify?.routes?.root || '/'}collections/${collectionHandle}`,
      location.origin,
    )
    url.searchParams.set('section_id', sectionId)

    // Fade out current section for smoother UX
    hostSection.style.opacity = 0.5

    const html = await fetch(url).then((r) => r.text())
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const newSection = doc.getElementById(`shopify-section-${sectionId}`)
    if (!newSection) return

    newSection.style.opacity = 0.5

    sectionWrapper.replaceWith(newSection)

    // Fade in the new section after a short tick
    requestAnimationFrame(() => {
      newSection.style.transition = 'opacity 0.5s'
      newSection.style.opacity = 1
    })

    if (updateURL) window.updateURLwithParams(url, urlParams)

    document.dispatchEvent(new Event('collection-grid-loaded'))

    const selectedTitleWrapper = document.querySelector('.pfc-selected-title__wrapper')
    const targetSection = selectedTitleWrapper || newSection

    callback(targetSection)
  } catch (err) {
    console.error('loadCollectionGrid failed:', err)
  }
}
window.loadCollectionGrid = loadCollectionGrid

function updateActiveCard(card) {
  const item = card.closest('li') || card
  const list = item.parentElement
  if (!list) return

  list
    .querySelectorAll('.product-family-card.active')
    .forEach((el) => el.classList.remove('active'))
  card.classList.add('active')

  const selectedTitleWrapper = document.querySelector('.pfc-selected-title__wrapper')
  if (!selectedTitleWrapper) return

  const newTitle = card.querySelector('h3')?.textContent
  if (!newTitle) return

  const titleElement = selectedTitleWrapper.querySelector('.pfc-selected-title__title')
  titleElement.style.opacity = 0
  setTimeout(() => {
    titleElement.textContent = newTitle
    titleElement.style.opacity = 1
  }, 125)
}
window.updateActiveCard = updateActiveCard

async function updatePDP(productHandle) {
  const productInfo = document.querySelector('.shopify-section.liquid-pdp product-info')
  if (!productInfo) return

  document.addEventListener('product-info-updated', () => {
    const prodInfo = document.querySelector('.shopify-section.liquid-pdp product-info')
    if (prodInfo) {
      window.scrollToSection(prodInfo, 78)
      const childCategoryName = prodInfo.dataset.childCategoryName
      if (childCategoryName) {
        const breadcrumbsWrapper = document.querySelector('.liquid-pdp__breadcrumbs')
        const childCategoryNameElement = breadcrumbsWrapper.querySelector('.child-category-name')
        if (childCategoryNameElement) {
          childCategoryNameElement.textContent = childCategoryName
            .replace(/Boys'|Boys|Girls'|Girls|Womens|Mens|Tall/g, '')
            .trim()
        }
      }
    }
  })

  requestAnimationFrame(() => {
    productInfo.style.transition = 'opacity 0.5s'
    productInfo.style.opacity = 0.5
    productInfo.style.pointerEvents = 'none'
  })

  productInfo.changeFullSection(productHandle, window.isMultiFamilyLp === true ? false : true)

  const wrapper = document.querySelector('.product-family-cards')
  if (!wrapper) return
  const cards = wrapper.querySelectorAll('.product-family-card')
  Array.from(cards).forEach((child) => {
    child.classList.remove('active')
    if (child.dataset.productHandle === productHandle) child.classList.add('active')
  })
}
window.updatePDP = updatePDP
